<template>
  <div>
    <button
      @click="backToSearchResults"
      class="flex underline hover:no-underline text-gray-500 p-0"
    >
      Terug naar zoekresultaten
    </button>
  </div>
</template>

<script>
export default {
  methods: {
    backToSearchResults: function() {
      this.$router.push({ path: "/", hash: "searchResults" });
    }
  }
};
</script>

<style></style>
